import { useTranslation } from 'react-i18next';
import React from 'react';
import { Eye, X } from 'lucide-react';
import usePermissions from '../hooks/usePermissions';
import { Button } from './ui/button';

/**
 * Sticky banner shown at the top of the app whenever an admin /
 * superadmin is previewing the UI as another role. Clicking "Exit
 * preview" restores their own permissions immediately (no reload).
 */
const ViewAsRoleBanner = () => {
  const { t } = useTranslation();
  const { viewAsRole, setViewAsRole, label } = usePermissions();
  if (!viewAsRole) return null;
  return (
    <div
      className="sticky top-0 z-50 w-full bg-amber-500 text-white shadow-md"
      data-testid="view-as-role-banner"
    >
      <div className="max-w-[1800px] mx-auto px-3 sm:px-6 py-2 flex items-center justify-between gap-3 text-sm">
        <div className="flex items-center gap-2 min-w-0">
          <Eye className="h-4 w-4 shrink-0" />
          <span className="truncate">
            <span className="font-semibold">{t('auto.misc2.previewMode')}</span>{' '}
            viewing the app as <span className="font-mono bg-amber-600/40 px-1.5 py-0.5 rounded">{label || viewAsRole}</span>
            <span className="hidden sm:inline opacity-80"> {t('auto.misc2.yourActualPermissionsAreUnchanged')}</span>
          </span>
        </div>
        <Button
          size="sm"
          variant="secondary"
          className="shrink-0 h-7 text-xs bg-white text-amber-700 hover:bg-amber-50"
          onClick={() => setViewAsRole(null)}
          data-testid="exit-view-as-role-btn"
        >
          <X className="h-3 w-3 mr-1" /> {t('auto.misc2.exitPreview')}
        </Button>
      </div>
    </div>
  );
};

export default ViewAsRoleBanner;
